import React from 'react'

function TrackCardRows ({ children }) {
  return (
    <div className='overflow-x-auto flex'>
      <div className='divide-y divide-gray-200 inline-block flex-grow'>
        {children}
      </div>
    </div>
  )
}

export default TrackCardRows
